import moment from "moment";
import { MonthNames, QuarterNames } from "../constants";

export const getComparingDates = (preLastData, lastData, interval) => {
    switch (interval) {
        case "hour":
            return [
                moment.utc(lastData.label).format("M.D.YY HH:mm"),
                moment.utc(preLastData.label).format("M.D.YY HH:mm"),
            ];

        case "day":
            return [
                moment.utc(lastData.label).format('M.D.YY'),
                moment.utc(preLastData.label).format('M.D.YY'),
            ];

        case "week":
            return [
                `${moment.utc(lastData.label).startOf('isoWeek').format('M.D.YY')} - ${moment.utc(lastData.label).endOf('isoWeek').format('M.D.YY')}`,
                `${moment.utc(preLastData.label).startOf('isoWeek').format('M.D.YY')} - ${moment.utc(preLastData.label).endOf('isoWeek').format('M.D.YY')}`,
            ];

        case "month":
            return [
                `${MonthNames[moment.utc(lastData.label).month()]} ${moment.utc(lastData.label).year()}`,
                `${MonthNames[moment.utc(preLastData.label).month()]} ${moment.utc(preLastData.label).year()}`,
            ];

        case "quarter":
            const getQuarterKey = (date) => {
                const month = moment.utc(date).month();
                if (month >= 0 && month <= 2) return 0;
                if (month >= 3 && month <= 5) return 3;
                if (month >= 6 && month <= 8) return 6;
                return 9;
            };

            const lastQuarterKey = getQuarterKey(lastData.label);
            const preLastQuarterKey = getQuarterKey(preLastData.label);

            return [
                `${QuarterNames[lastQuarterKey]} ${moment.utc(lastData.label).year()}`,
                `${QuarterNames[preLastQuarterKey]} ${moment.utc(preLastData.label).year()}`,
            ];


        case "year":
            return [
                `${moment.utc(lastData.label).year()}`,
                `${moment.utc(preLastData.label).year()}`,
            ];

        default:
            return [];
    }
};
